<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App',
  components: {
  },
  updated () {
    window.scroll(0, 0)
  }
}
</script>

<style>
#app {
  background-color: #f5f5f5;
  width: 1200px;margin: auto;
}
</style>



// WEBPACK FOOTER //
// src/App.vue